// MUI
import { Box } from "@mui/material";

// Hooks
import { useTechnicianFlaggedTimeQuery } from "./hooks/useTechnicianFlaggedTimeQuery";

// Helpers
import { getFormatUTCDate } from "@/Common/helpers/Dates";
import { and } from "@Common/helpers/sonar";

// Layouts
import TextIconMessage from "@/Layouts/components/Basics/TextIconMessage";

// Components
import { TFTModelHeader } from "./components/TFTModelHeader";
import { TFTModelTable } from "./components/TFTModelTable";

// Types
import { IPeriodTreeSelection } from "@/Layouts/components/SideBars/PayPeriodSideBar/interfaces";

import { ITechnicianFlaggedTime } from "@/DataPages/types/technicianFlaggedTime/model";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

interface ITechnicianFlaggedTimeModelProps {
	selected: IPeriodTreeSelection;
	dataPresent?: boolean;
	isLoading?: boolean;
	isTabSelected: boolean;
	isUpdatable?: boolean;
	hasPermission: boolean;
}

export default function TFTModel(props: Readonly<ITechnicianFlaggedTimeModelProps>) {
	const { selected, isTabSelected, hasPermission } = props;

	// Queries
	const {
		technicianPerformance,
		isLoading: isTechnicianPerformanceLoading,
		hasNextPage,
	} = useTechnicianFlaggedTimeQuery({
		cycleId: selected?.cycleId,
		payPeriodId: selected?.payPeriodId,
		enabled: and(Boolean(selected?.cycleId), Boolean(selected?.payPeriodId), isTabSelected, hasPermission),
	});

	return (
		<>
			<TFTModelHeader isLoading={isTechnicianPerformanceLoading} selected={selected} isUpdatable />
			<TFTModelTable
				hasNextPage={hasNextPage}
				data={technicianPerformance as unknown as ITechnicianFlaggedTime}
				isLoading={isTechnicianPerformanceLoading}
				technicianPerformance={technicianPerformance}
			/>
			<Box className="pt-8 [&_svg]:!text-default">
				<TextIconMessage
					icon
					title={"Last modified on"}
					content={getFormatUTCDate(technicianPerformance?.lastModifiedOn ?? 0, DATE_FORMAT.usDateTime12hUnpadded)}
					showContent={Boolean(technicianPerformance?.lastModifiedOn)}
					loading={isTechnicianPerformanceLoading}
				/>
			</Box>
		</>
	);
}
